import { render, staticRenderFns } from "./DeleteTasks.vue?vue&type=template&id=76fddaed&scoped=true&"
import script from "./DeleteTasks.vue?vue&type=script&lang=js&"
export * from "./DeleteTasks.vue?vue&type=script&lang=js&"
import style0 from "./DeleteTasks.vue?vue&type=style&index=0&id=76fddaed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fddaed",
  null
  
)

export default component.exports